var AR = require('component/core/index.js');
import myReport from 'component/my-report/index.js';
const text = require('./text.yaml')[templateVars.lang];
const config = require('./config.yaml');
var toastCount = 0;

function toast(content, time) {
	time = time || 3000;

	toastCount = toastCount + 1;
	$('.toast').append('<div class="toast__message m' + toastCount + '">' + content + '</div>');

	setTimeout(removeToast, time, toastCount);
}

function removeToast(tc) {
	$('.m' + tc).remove();
}

function clearLinkInOffline() {
	const itemsToHide = [
		'.buttons-panel__link--myreport',
		'.buttons-panel__link--feedback',
		'.buttons-panel__link--download',
		'.buttons-panel__link--share',
		'.buttons-panel__link--history',
		'.buttons-panel__link--pdf',
		'.buttons-panel__link--offline',
		'.buttons-panel__link--add'
	];

	var $panel = $('.buttons-panel');
	$panel.find(itemsToHide.join(', ')).parent().detach();
}

if (AR.offline) {
	clearLinkInOffline();
}

function getMyReportLength() {
	myReport.getLength()
		.then((value) => {
			$('.buttons-panel__counter').html(value);
		});
}

if ($('.buttons-panel--tools').length) {
	const $addBtn = $('.buttons-panel__link--add');
	const $delBtn = $('.buttons-panel__link--del');
	const pageKey = templateVars.siteUrl.path;

	myReport.checkPageOnExist(pageKey)
		.then((value) => {
			if (value) {
				$addBtn.hide();
				$delBtn.css('display', 'block');
			}
		});

	getMyReportLength();

	$addBtn.on('click', function () {
		myReport
			.add()
			.then(getMyReportLength);

		$addBtn.hide();
		$delBtn.css('display', 'block');
	});

	$delBtn.on('click', function () {
		myReport
			.removeItem(pageKey)
			.then(getMyReportLength);

		$delBtn.hide();
		$addBtn.css('display', 'block');
	});
}

$('.buttons-panel__trigger').each(function () {
	const $this = $(this);
	const itemsLength = $this
		.closest('.buttons-panel')
		.find('.buttons-panel__item')
		.length;

	if (!itemsLength) {
		if (config.ifEmptyPanel === 'remove') {
			$this.remove();
		} else {
			$this.attr('disabled', 'disabled');
		}
	}
});

global.buttonsPanelOpenLink = function buttonsPanelOpenLink(link) {
	window.open(link, '', 'scrollbars=yes,resizable=no,width=560,height=350,top=' + Math.floor((screen.height - 350) / 2 - 14) + ',left=' + Math.floor((screen.width - 560) / 2 - 5));
	return false;
};



// WEBPACK FOOTER //
// ./temp/components/buttons-panel/index.js